<template>
  <div>
    <div class="pg-home common-holder" style="display: block;">
      <div class="content-holder">
        <div class="section-banner">
          <swiper v-bind="swiperOptions" class="banner box slick-initialized slick-slider slick-dotted">
            <swiper-slide class="slick-slide">
              <img class="img-responsive" src="/static/img/landing/34_1683535038516_phpC9NRpb.jpg" alt="banner" />
            </swiper-slide>
            <swiper-slide class="slick-slide">
              <a target="_blank#" href="#" tabindex="-1"><img class="img-responsive"
                  src="/static/img/landing/34_1680235183409_php2TVISb.jpg" alt="banner" /></a>
            </swiper-slide>
            <swiper-slide class="slick-slide">
              <a target="_blank#" href="#" tabindex="-1"><img class="img-responsive"
                  src="/static/img/landing/5_1684901804051_phpHNIMe0.jpg" alt="banner" /></a>
            </swiper-slide>
            <swiper-slide class="slick-slide">
              <img class="img-responsive" src="/static/img/landing/23_1678442148471_phpeXlLvX.jpg" alt="banner" />
            </swiper-slide>
            <swiper-slide class="slick-slide">
              <a target="_blank#" href="#" tabindex="-1"><img class="img-responsive"
                  src="/static/img/landing/5_1662187024696_phpauOPxi.jpg" alt="banner" /></a>
            </swiper-slide>
          </swiper>
          <div class="top-player box d-dev sp-box"></div>
        </div>
        <div class="product-category mgt30 d-dev">
          <a data-type="live" href="/th-th/live" class="list list-casino">
            <span>คาสิโนสด</span> </a><a data-type="slot" href="/th-th/slot" class="list list-slot">
            <span>สล็อต</span> </a><a data-type="card" href="/th-th/card" class="list list-poker">
            <span>การ์ด</span> </a>
        </div>
        <div class="m-dev">
          <div class="product-sub-category mgt30">
            <div class="list">
              <a class="sub-promo" href="#">
                <div class="sub-img">
                  <img src="/static/img/landing/promo.png" alt="promotions" />
                </div>
                <div class="sub-title">
                  <h5>โปรโมชั่น</h5>
                  <span>พบกับโปรโมชั่นมากมายที่ห้ามพลาด!</span>
                </div>
              </a>
            </div>
            <div class="list">
              <a class="sub-vip" href="#">
                <div class="sub-img">
                  <img src="/static/img/landing/vip.png" alt="vip" />
                </div>
                <div class="sub-title">
                  <h5>วีไอพี</h5>
                  <span>มาเป็น VIP
                    เพื่อเพลิดเพลินกับสิทธิพิเศษระดับพรีเมียมของเรา</span>
                </div>
              </a>
            </div>
            <div class="list">
              <a class="sub-aff" href="#">
                <div class="sub-img">
                  <img src="/static/img/landing/aff.png" alt="aff" />
                </div>
                <div class="sub-title">
                  <h5>พันธมิตร</h5>
                  <span>เข้าร่วมตอนนี้เพื่อรับคอมมิชชั่นพิเศษ</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="game-show features-game posRel mgt45">
          <div class="vp-title">คาสิโน</div>
          <div class="featuredGame-control">
            <div class="featuredGame exclusive-prev disabled" data-type="show">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </div>
            <div class="featuredGame exclusive-next" data-type="show">
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </div>
          </div>

          <div class="v-gameshow game mgt25">
            <div class="list">
              <div class="box" data-gameid="9350" data-name="Game Shows" data-pid="101">
                <div class="image lazy" data-src="/static/img/landing/171x305/5.png"
                  role="img" title="Game Shows"
                  style="background-image: url('/static/img/landing/171x305/5.png');">
                </div>
                <span class="name">
                  <span>Sexy Gaming</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="9350" data-name="Game Shows" data-pid="101">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="13522" data-name="Boom City" data-pid="101">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/6.png" role="img"
                  title="Boom City"
                  style="background-image: url('/static/img/landing/171x305/6.png');">
                </div>
                <span class="name">
                  <span>WM</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="13522" data-name="Boom City" data-pid="101">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="9409" data-name="Sweet Bonanza Candyland" data-pid="101">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/9.png"
                  role="img" title="Sweet Bonanza Candyland"
                  style="background-image: url('/static/img/landing/171x305/9.png');">
                </div>
                <span class="name">
                  <span>AG Gaming</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="9409" data-name="Sweet Bonanza Candyland"
                    data-pid="101">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="9351" data-name="Mega Wheel" data-pid="101">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/1.png" role="img"
                  title="Mega Wheel"
                  style="background-image: url('/static/img/landing/171x305/1.png');">
                </div>
                <span class="name">
                  <span>Pragmatic Play</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="9351" data-name="Mega Wheel" data-pid="101">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="11299" data-name="Crazy Time" data-pid="2">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/2.png" role="img"
                  title="Crazy Time"
                  style="background-image: url('/static/img/landing/171x305/2.png');">
                </div>
                <span class="name">
                  <span>Pretty Gaming</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="11299" data-name="Crazy Time" data-pid="2">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="11300" data-name="Deal or No Deal" data-pid="2">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/3.png"
                  role="img" title="Deal or No Deal"
                  style="background-image: url('/static/img/landing/171x305/3.png');">
                </div>
                <span class="name">
                  <span>Rich88</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="11300" data-name="Deal or No Deal" data-pid="2">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="11306" data-name="Mega Ball" data-pid="2">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/4.png" role="img"
                  title="Mega Ball"
                  style="background-image: url('/static/img/landing/171x305/4.png');">
                </div>
                <span class="name">
                  <span>SA Gaming</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="11306" data-name="Mega Ball" data-pid="2">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="11307" data-name="Monopoly Live" data-pid="2">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/7.png" role="img"
                  title="Monopoly Live"
                  style="background-image: url('/static/img/landing/171x305/7.png');">
                </div>
                <span class="name">
                  <span>XTREME Gaming</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="11307" data-name="Monopoly Live" data-pid="2">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="14557" data-name="XXXtreme Lightning Roulette " data-pid="2">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/10.png"
                  role="img" title="XXXtreme Lightning Roulette "
                  style="background-image: url('/static/img/landing/171x305/10.png');">
                </div>
                <span class="name">
                  <span>Allbet</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="14557" data-name="XXXtreme Lightning Roulette "
                    data-pid="2">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="11305" data-name="Lightning Dice" data-pid="2">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/11.png" role="img"
                  title="Lightning Dice"
                  style="background-image: url('/static/img/landing/171x305/11.png');">
                </div>
                <span class="name">
                  <span>BigGame</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="11305" data-name="Lightning Dice" data-pid="2">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="11298" data-name="Cash or Crash" data-pid="2">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/12.png" role="img"
                  title="Cash or Crash"
                  style="background-image: url('/static/img/landing/171x305/12.png');">
                </div>
                <span class="name">
                  <span>Dream Gamung</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="11298" data-name="Cash or Crash" data-pid="2">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="14280" data-name="Crazy Coin Flip" data-pid="2">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/13.png" role="img"
                  title="Crazy Coin Flip"
                  style="background-image: url('/static/img/landing/171x305/13.png');">
                </div>
                <span class="name">
                  <span>EBET</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="14280" data-name="Crazy Coin Flip" data-pid="2">
                    เล่น
                  </div>
                </div>
              </div>
              <div class="box" data-gameid="9291" data-name="Fortune Wheel / Dream Catcher" data-pid="2">
                <div class="image lazy"
                  data-src="/static/img/landing/171x305/14.png" role="img"
                  title="Fortune Wheel / Dream Catcher"
                  style="background-image: url('/static/img/landing/171x305/14.png');">
                </div>
                <span class="name">
                  <span>Evolution Gaming</span>
                  <!--<div class="button-round button-sub-cta">
                        <i class="fa-solid fa-heart"></i>
                    </div>-->
                </span>
                <div class="provider-name">casino</div>
                <div class="box-play">
                  <div class="button-play boxGoPlay" data-gameid="9291" data-name="Fortune Wheel / Dream Catcher"
                    data-pid="2">
                    เล่น
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="popular-game features-game posRel mgt45">
          <div class="vp-title">เกมสล็อต</div>
          <div class="exclusive-prev" style="opacity: 0.5;">
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </div>
          <div class="v-popular game mgt25">
            <div class="list">
              <div class="holder holder_1">
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/pg.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/pg.png');">
                  </div>
                  <span class="name">
                    <span>PG soft</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/slotXO.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/slotXO.png');">
                  </div>
                  <span class="name">
                    <span>slotXO</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/JILI.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/JILI.png');">
                  </div>
                  <span class="name">
                    <span>JILI</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/pragmaticplay.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/pragmaticplay.png');">
                  </div>
                  <span class="name">
                    <span>pragmaticplay</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/rlx.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/rlx.png');">
                  </div>
                  <span class="name">
                    <span>RELAX Gaming</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/AMB.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/AMB.png');">
                  </div>
                  <span class="name">
                    <span>AMB</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/AMBPOKER.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/AMBPOKER.png');">
                  </div>
                  <span class="name">
                    <span>AMBPOKER</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/ask-me-bet.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/ask-me-bet.png');">
                  </div>
                  <span class="name">
                    <span>ask-me-bet</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/joker2.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/joker2.png');">
                  </div>
                  <span class="name">
                    <span>joker</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/KINGMAKER.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/KINGMAKER.png');">
                  </div>
                  <span class="name">
                    <span>KINGMAKER</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/Mp.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/Mp.png');">
                  </div>
                  <span class="name">
                    <span>Mp</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/NETENT2.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/NETENT2.png');">
                  </div>
                  <span class="name">
                    <span>NETENT</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
              </div>
              <div class="holder holder_2">
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/simpleplay.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/simpleplay.png');">
                  </div>
                  <span class="name">
                    <span>simpleplay</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/spadegaming.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/spadegaming.png');">
                  </div>
                  <span class="name">
                    <span>spadegaming</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/CQ9.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/CQ9.png');">
                  </div>
                  <span class="name">
                    <span>CQ9</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/waz.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/waz.png');">
                  </div>
                  <span class="name">
                    <span>WAZDAN</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/ps3.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/ps3.png');">
                  </div>
                  <span class="name">
                    <span>PlayStar</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/funky.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/funky.png');">
                  </div>
                  <span class="name">
                    <span>Funky Game</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/red.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/red.png');">
                  </div>
                  <span class="name">
                    <span>Red Tiger</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
                <div class="box" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                  <div class="image lazy"
                    data-src="/static/img/landing/287x200/TRADING.png"
                    role="img" title="Baccarat EU 1"
                    style="background-image: url('/static/img/landing/287x200/TRADING.png');">
                  </div>
                  <span class="name">
                    <span>Hotgraph</span>
                    <!--<div class="button-round button-sub-cta">
                                <i class="fa-solid fa-heart"></i>
                            </div>-->
                  </span>
                  <div class="provider-name">slot</div>
                  <div class="box-play">
                    <div class="button-play boxGoPlay" data-gameid="17199" data-name="Baccarat EU 1" data-pid="132">
                      เล่น
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="exclusive-next">
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </div>
        </div>
        <div class="d-dev">
          <div class="product-sub-category mgt45">
            <div class="list">
              <div class="vp-title">โปรโมชั่นล่าสุด</div>
              <a class="sub-promo" href="#">
                <div class="sub-img">
                  <img src="/static/img/landing/promo.png" alt="promotions" />
                </div>
                <div class="sub-title">
                  <h5>โปรโมชั่น</h5>
                  <span>พบกับโปรโมชั่นมากมายที่ห้ามพลาด!</span>
                </div>
              </a>
            </div>
            <div class="list">
              <div class="vp-title">โปรแกรมวีไอพี</div>
              <a class="sub-vip" href="#">
                <div class="sub-img">
                  <img src="/static/img/landing/vip.png" alt="vip" />
                </div>
                <div class="sub-title">
                  <h5>วีไอพี</h5>
                  <span>มาเป็น VIP
                    เพื่อเพลิดเพลินกับสิทธิพิเศษระดับพรีเมียมของเรา</span>
                </div>
              </a>
            </div>
            <div class="list">
              <div class="vp-title">โปรแกรมในเครือ</div>
              <a class="sub-aff" href="#">
                <div class="sub-img">
                  <img src="/static/img/landing/aff.png" alt="aff" />
                </div>
                <div class="sub-title">
                  <h5>พันธมิตร</h5>
                  <span>เข้าร่วมตอนนี้เพื่อรับคอมมิชชั่นพิเศษ</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="product-lottery-category mgt45">
          <div class="lottery-footer">
            <div>
              <div class="lottery-title">
                <!-- <lottie-player class="flame" src="/static/img/landing/hot.json" background="transparent" speed="1" loop=""
                  autoplay=""></lottie-player> -->
                <span>ฝาก - ถอน <br>ด้วยระบบอัตโนมัติ</span>
              </div>
              <div class="lottery-subtitle">เสถียร เพราะไม่ต้องผ่านเอเย่นต์</div>
            </div>
            <div class="lottery-img">
              <img src="/static/img/landing/lottery_bg.png" alt="lottery-img" />
            </div>
            <a class="button-lottery d-dev" href="#"><span>เล่นเลย</span></a>
          </div>
        </div>
        <div id="lineLoad" class="hide"></div>
        <div id="lineLoadOpt2" class="hide"></div>
      </div>

      <div class="angpowFloat-holder hide ui-draggable ui-draggable-handle">
        <div class="angpowFloat-header">
          <span></span>
          <i class="fa fa-times closeAngpowFloat" aria-hidden="true"></i>
        </div>
        <div class="angpowFloat-container">
          <!-- <lottie-player class="menu" src="https://www.22funth.com/asset_web/img//common/angpow_side_logo.json"
            background="transparent" speed="1" loop="" autoplay=""></lottie-player> -->
        </div>
      </div>
      <div class="vContactUS dd hide">
        <div class="xBG">
          <i class="fa-regular fa-user-headset"></i>
          <div class="xContactSpan"><span>ติดต่อพวกเรา</span></div>
        </div>
        <div class="xContactListF">
          <div class="xRow">
            <div class="xIcon lChat">
              <i class="fa-regular fa-user-headset"></i>
            </div>
            <div class="xText">
              แชทสด
              <p class="vBtnLaiveChat">เริ่มต้น</p>
            </div>
          </div>
          <div class="xRow">
            <div class="xIcon line">
              <img class="img-responsive"
                src="https://22fun-public.s3.ap-southeast-1.amazonaws.com/frontend/asset_web/img/social/line.svg?v=50"
                alt="line" />
            </div>
            <div class="xText">
              Line
              <p>
                <a href="https://line.me/ti/p/https://line.me/ti/p/~https://lin.ee/WClijEl"
                  target="_blank#">https://lin.ee/WClijEl</a>
              </p>
            </div>
          </div>
          <div class="xRow">
            <div class="xIcon phone">
              <img class="img-responsive"
                src="https://22fun-public.s3.ap-southeast-1.amazonaws.com/frontend/asset_web/img/social/phone.svg?v=50"
                alt="phone" />
            </div>
            <div class="xText">
              Phone
              <p><a href="tel:0633487799" target="_blank#">0633487799</a></p>
            </div>
          </div>
        </div>
      </div>
      <div id="QrImages" class="">

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getPrefix } from "@/services/modules/global.js";
import { reward } from "@/config/reward.js";
import carousel from "vue-owl-carousel";
import LoginForm from "@/components/form/LoginForm";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

import RegisterForm from "@/components/form/RegisterForm";
// import VueSlickCarousel from "vue-slick-carousel";
// import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import carousel from "vue-owl-carousel";

import { EffectCoverflow, Navigation, Pagination, Autoplay } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import "swiper/swiper-bundle.css";
SwiperCore.use([Navigation, Pagination, Autoplay, EffectCoverflow]);
// import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import api from "@/services/index.js";

export default {
  name: "Index",

  data() {
    return {
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,
      showHeader: false,
      gameTab: 0,
      swiperOptions: {
        loop: true,
        slidesPerView: 1,
        navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
      },
      swiperMatchOptions: {
        loop: true,
        slidesPerView: 1,
        navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
      },
      availableBalance: "Loading...",
      availableCredit: "Loading...",
      isShowGame: true,
      chList: [],
      gameList: [],
      inGameList: false,
      ischName: "บริการของเรา",
      havelink: 0,
      gameListChunk: [],
      gameType: true,
      gameCH: this.$route.params.ch,
      chSlotList: [],
      gameCH: undefined,
      gameImg: "",
      gameType: "",
      gameCategory: "",
      productId: "",
      category:
        this.$route.params.category == undefined
          ? "Casino"
          : this.$route.params.category,
      tab: 1,
    };
  },

  components: {
    Header,
    Swiper,
    SwiperSlide,
    Footer,
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "appTitle",
    ]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    gotoRoute(route) {
      this.$router.push(route);
    },
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    gotoCategory(category) {
      this.inGameList = false;
      this.category = category;
      this.$router.push(`/play/${category}`).catch(() => { });
    },

    gotoSub(route, item) {
      (this.gameImg = item.img
        .replace("game", "game_tranparent")
        .replace("game_betflik", "game_betflik_tranparent")),
        (this.gameType = item.gameType),
        (this.gameCategory = item.gameCategory),
        this.getGames(item.ch, item.gameType, item.category);
    },
    // async getChannels() {
    //   console.log("getChannels");

    //   await api
    //     .get("/user-profile-composite/v1/products")
    //     .then((v) => {
    //       if (v.success == true) {
    //         this.chList = v.data;
    //       } else {
    //         this.$swal.fire("แจ้งเตือน", v.message, "error");
    //       }
    //     })
    //     .catch((e) => {
    //       this.$swal.fire("แจ้งเตือน", e.message, "error");
    //     })
    //     .finally(() => {});
    // },
    async LoginGame(gameCode) {
      setTimeout(async () => {
        await api
          .get(`/user-profile-composite/v1/logIn/${this.productId}/${gameCode}`)
          .then((v) => {
            if (v.success == true) {
              if(v.data.url){
                setTimeout("location.href = '" + v.data.url + "';", 100);
              }else{
                this.$swal.fire("ไม่พบตัวเกม กรุณาลองใหม่อีกครั้ง", "", "error");
              }
            } else {
              this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            this.$swal.fire("แจ้งเตือน", e.message, "error");
          })
          .finally(() => { });
      }, 3000);
    },
    async getGames(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }
        console.log("NO LOBBY");
        console.log(filter);
        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire("แจ้งเตือน", e.message, "error");
            }
          })
          .finally(() => { });
      }
    },

    async getGamesPage(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }

        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              this.$router
                .replace(`/play/${this.category}/${filter}/${chId}`)
                .catch(() => { });
              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire("แจ้งเตือน", e.message, "error");
            }
          })
          .finally(() => { });
        // this.$router.push({ name: 'play', params: { category: this.category } });
        // this.$router.replace(`/play/${this.category}/${filter}/${chId}`).catch(() => { });
      }
    },
  },
  async mounted() {
    this.setError(null);
    if (localStorage.getItem("remember.username") != null) {
      this.phoneNumber = localStorage.getItem("remember.username");
      this.remember = true;
    }
    if (localStorage.getItem("remember.password") != null) {
      this.password = localStorage.getItem("remember.password");
      this.remember = true;
    }

    // await this.getChannels();

    if (this.$route.params.category != undefined) {
      this.category = this.$route.params.category;
      console.log(this.$route.params.category);

      if (
        this.$route.params.ch == undefined &&
        this.$route.params.gameType == undefined
      ) {
        console.log("chchch");
      } else {
        this.category = this.$route.params.category;
        this.inGameList = true;
        console.log("gameTypegameTypegameType");
        console.log(this.$route.params.gameType);
        console.log(this.$route.params.ch);
        this.getGames(
          this.$route.params.ch,
          this.$route.params.gameType,
          this.$route.params.category
        );
      }
    }
  },
};
</script>

<style scoped>
.home-banner-app-download {
  position: relative;
}

.app-qr-img,
.app-left-logo {
  width: 6%;
  position: absolute;
  top: 62%;
  transform: translate(0%, -50%);
}

.app-left-logo {
  right: 12.1%;
}

.app-qr-img {
  right: 3.6%;
}

.download-banner {
  width: 100%;
  border-radius: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/Index.vue